<template>
  <UModal
    v-model:open="isOpen"
    :prevent-close="true"
    :title="t('comps.modalReturnError.title')"
  >
    <template #body>
      <!-- <h2 class="text-2xl">
        {{ t('comps.modalReturnError.title') }}
      </h2> -->
      <LayoutP class="!m-0">
        {{ t('comps.modalReturnError.description', { email: data.ngo.email }) }}
      </LayoutP>
      <UButton
        :label="t('comps.modalReturnError.btnContinue')"
        class="text-center mt-6"
        size="lg"
        @click="isOpen = false"
      />
    </template>
  </UModal>
</template>

<script lang="ts" setup>
import getData from '#shared/utils/getData'

const { data } = getData()
const isOpen = ref(false)

onMounted(() => {
  const route = useRoute()
  if ('return-error' in route.query) {
    isOpen.value = true
  }
})
</script>
